import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewTeamMembersList = (teamData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_TEAM_MEMBERS_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/staff/list`,
        teamData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_TEAM_MEMBERS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_TEAM_MEMBERS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_TEAM_MEMBERS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addTeamMember = (memberData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_MEMBER_REQUEST" });
      console.log("BASE_URL:", process.env.REACT_APP_API_BASE_URL);

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/staff/create`,
        memberData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_MEMBER_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_MEMBER_FAILED", payload: data });
        toast.error("Something went wrong!!");
      }
    } catch (error) {
      dispatch({ type: "ADD_MEMBER_FAILED", payload: error.message });
      toast.error("Something went wrong!!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewTeamMembersListNoPagination = (teamData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_TEAM_MEMBERS_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/staff/alllist`,
        teamData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_TEAM_MEMBERS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_TEAM_MEMBERS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_TEAM_MEMBERS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const blockUnblockMember = (blockUnblockData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "BLOCK_UNBLOCK_MEMBER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/staff/block-unblock`,
        blockUnblockData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "BLOCK_UNBLOCK_MEMBER_SUCCESS", payload: data });
        toast.success("Operation successful!");
        return data;
      } else {
        dispatch({ type: "BLOCK_UNBLOCK_MEMBER_FAILED", payload: data });
        toast.error("Something went wrong!!");
      }
    } catch (error) {
      dispatch({ type: "BLOCK_UNBLOCK_MEMBER_FAILED", payload: error.message });
      toast.error("Something went wrong!!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

